import React, { useEffect, useState } from "react";
import { Field } from "formik";
import PropTypes, { array } from "prop-types";
import PublishSharpIcon from "@material-ui/icons/PublishSharp";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import InputLabel from "@material-ui/core/InputLabel";
import InfoIcon from "@material-ui/icons/Info";
import Grid from "@material-ui/core/Grid";

import HoverTooltip from "@Components/Tooltip/HoverTooltip";
import useStyles from "assets/jss/material-dashboard-react/components/customFileUploadStyle";
import IconButton from "@material-ui/core/IconButton";
import { useTranslation } from "react-i18next";

function FileUpload(props) {
  const { name, accept, label, required, buttonText, supportedTypes,supportedFormat } = props;
  const [UnsupportedTypes, setUnsupportedTypes] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles();


  let supportedTypeMessage;
  if (supportedTypes) {
    const modifiedSupportedTypes = supportedTypes.map((type) => `.${type}`);
    supportedTypeMessage = modifiedSupportedTypes.join(", ");

  }


  return (
    <Field name={name}>
      {(props) => {
        const { field, form, meta } = props;
        const { setFieldValue } = form;

        const downloadFile = () => {
          const link = document.getElementById("link");
          link.href = field.value;
          link.setAttribute("download", link.href);
        };

        useEffect(() => {
          downloadFile();
        }, [field.value]);

        const getFilename = () => {
          if (typeof field.value === "object") {
            return field.value.name;
          }
          return field.value.split("/").slice(-1)[0];
        };
        const fieldValue = field.value ? getFilename() : null;
        return (
          <>
            <InputLabel
              className={clsx(classes.label, {
                [classes.error]: meta.touched && meta.error,
              })}
            >
              <Grid container direction="row" alignItems="center" spacing={1}>
              <Grid item>
        {label}
    </Grid>                
    {required ? <Grid item>
      <span style={{ color: "red" }}> * </span>
        </Grid> : null}
                <HoverTooltip title={`${supportedTypeMessage}`}>
                  <IconButton style={{ padding: "0" }}>
                    <InfoIcon color="primary" />
                  </IconButton>
                </HoverTooltip>
              </Grid>

            </InputLabel>

            <div className="uploadButton" style={{ margin: "6px" }}>
              <input
                id={name}
                name={name}
                type="file"
                accept={accept}
                style={{ display: "none" }}
                onInput={(event) => {
                  let fileObj = event.target.files[0];
                  setFieldValue(name, fileObj);
                  
                  if (supportedFormat) {
                    if (fileObj.type !== supportedFormat) {
                      setUnsupportedTypes(true);
                    }
                    else {
                      setUnsupportedTypes(false);

                    }
                  }
                  const link = document.getElementById("link");
                  let objectURL = URL.createObjectURL(fileObj);
                  link.download = fileObj.name;

                  link.href = objectURL;
                }}
                value=""
              />

              <label htmlFor={name}>
                <Button
                  style={{ textTransform: "capitalize" }}
                  variant="contained"
                  component="span"
                  color="primary"
                  startIcon={<PublishSharpIcon />}
                >
                  {buttonText ? t(buttonText) : t("Upload")}
                </Button>
              </label>

              <span
                className={
                  fieldValue ? classes.fileSelected : classes.fileNotSelected
                }
              >
                <a id="link" target="_blank" download>
                  {fieldValue ? fieldValue : t("No File Selected")}
                </a>
              </span>
              <br />
              {UnsupportedTypes && (
                <span style={{ color: "red" }}>
                  <b>Unsupported File Format</b>
                </span>
              )}
            </div>
          </>
        );
      }}
    </Field>
  );
}

FileUpload.propTypes = {
  name: PropTypes.string,
  accept: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.object,
  form: PropTypes.object,
  meta: PropTypes.object,
  buttonText: PropTypes.string,
  supportedTypes: PropTypes.array,
  supportedTypeMessage: PropTypes.array,
  supportedFormat: PropTypes.string,
};

export default FileUpload;
